import { render, staticRenderFns } from "./companyTableHeader.vue?vue&type=template&id=6e8549dc&scoped=true&"
import script from "./companyTableHeader.vue?vue&type=script&lang=js&"
export * from "./companyTableHeader.vue?vue&type=script&lang=js&"
import style0 from "./companyTableHeader.vue?vue&type=style&index=0&id=6e8549dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8549dc",
  null
  
)

export default component.exports